import type { ReportRunInput } from "@clubcore/api";

export type {
  DashboardPanel,
  DashboardTile,
  ReportChartSpec,
  ReportColumn,
  ReportDashboard,
  ReportDataset,
  ReportDefinition,
  ReportField,
  ReportParam,
  ReportRun,
  ReportRunInput,
  ReportSchedule,
  ReportShare,
  ReportTemplate,
  SavedReport,
} from "@clubcore/api";

/** What a report page runs: a definition that was built, a canned report with its parameters, or a saved report. Paging is added when it runs. */
export type RunSource = Omit<ReportRunInput, "page" | "page_size">;

/** The categories canned reports are grouped under, in the order they are shown. */
export const TEMPLATE_CATEGORIES = ["money", "golf", "members"] as const;

/** How many rows one page of a report holds. */
export const PAGE_SIZE = 100;
